const glossary = {
  adverbs: {
    by: 'par',
    for_more_than_days: 'depuis plus de {count}} jours',
    since: 'depuis',
    on: 'le',
    as_of: 'en date du',
    as_in: 'tel que dans',
    out_of: 'sur',
    per_month: 'par mois',
  },
  nouns: {
    '2fa': 'Authentification à deux facteurs',
    account: 'compte',
    account_name: "Nom du compte",
    choose_authentication_method: "Choisir la méthode d'authentification",
    authentication_mode: "Mode d'authentification",
    authentication_method: "Méthode d'authentification",
    change_password: 'Changer le mot de passe',
    current_password: 'Mot de passe actuel',
    authentication_mode_default: 'Par défaut',
    authentication_mode_google: 'Google',
    authentication_mode_office365: 'Microsoft',
    authentication_mode_sso: 'SSO',
    active: 'actif',
    active_users: 'utilisateurs actifs',
    active_users_capitalized: 'Utilisateurs actifs',
    actives: 'actifs',
    addiction: 'dépendance',
    advanced: 'avancées',
    address: {
      line_1: "Ligne d'adresse 1",
      line_2: "Ligne d'adresse 2",
      city: 'Ville',
      country: 'Pays',
      postal_code_zip: 'Code postal/ZIP',
      province_state: 'Province/État',
    },
    admin: 'administrateur',
    all: 'Tout',
    annual_instant_validation: 'rapports de candidats par année',
    api_key: 'clé API',
    report: 'Rapport',
    available: 'Complété',
    available_pending_twitter: 'Terminé, en attente de vérification de Twitter',
    available_pending_articles:
      'Terminé, en attente de vérification des articles',
    basic_information: 'Informations de base',
    preference_settings: 'Paramètres de préférence',
    billing: {
      billing: 'Facturation',
      email: 'Courriel de facturation',
      billing_information: 'Détails de facturation',
      billing_address: 'Adresse de facturation',
      next_payment: 'Prochain paiement',
      payment_details: 'Détails de paiement',
      payment_method: 'Mode de paiement',
      save_changes: 'Sauvegarder les modifications',
    },
    plans_and_payments: 'plans et facturation',
    city_of_residence: 'ville de résidence',
    clear: 'rien à signaler',
    clear_all: 'supprimer les filtres',
    clear_sorting: 'Effacer le tri',
    coming_soon: 'Bientôt disponible',
    company: 'entreprise',
    affiliated_organization: 'Organisations affiliées',
    user_reviewed: 'Revu',
    reviewed_by: 'Revu par',
    pep_soe: 'PPE/EAE',
    validation_list_settings: 'Paramètres de la liste des validations',
    validation_list_columns: 'Colonnes',
    pep: 'PPE/EAE',
    pepDescription: 'Personne politiquement exposée (PPE)',
    
    pep_status: {
      not_requested: 'Non demandé',
      not_available: 'Non disponible',
      true: 'PEP identifié',
      requested_not_returned: 'Demandé, non retourné',
      yes: 'Oui',
      no: 'Non',
      hoverHasPep:
        'Cette personne a été signalée comme une Personne Politiquement Exposée (PPE).',
      hoverNoPep:
        "Cette personne n'a pas été signalée comme une Personne Politiquement Exposée (PPE).",
      planIncluded: "Analyse PPE (Personne Politiquement Exposée) et EAE (Entreprise Appartenant à l'État) incluse dans votre plan",
      planNotIncluded: "Analyse PPE (Personne Politiquement Exposée) et EAE (Entreprise Appartenant à l'État) non incluse dans votre plan",
      request_toggle_hint: "Si activé, les nouvelles validations incluront le dépistage PPE/EAE",
      request_toggle_admin_only: "Seuls les propriétaires et administrateurs peuvent modifier ce paramètre",
      request_enabled_hint: "Le dépistage PPE/EAE est demandé pour les nouvelles validations",
      request_disabled_hint: "Le dépistage PPE/EAE n'est pas demandé pour les nouvelles validations",
      notRequested: "Non Demandé",
    },
    soe: 'EEP',
    soeDescription: `Entreprise Appartenant à l'État (EAE)`,
    soe_status: {
      not_requested: 'Non demandé',
      not_available: 'Non disponible',
      true: 'EEP identifiée',
      requested_not_returned: 'Demandée, non retournée',
      yes: 'Oui',
      no: 'Non',
      hoverHasSoe: `Signalée comme une Entreprise Appartenant à l'État (EAE)`,
      hoverNoSoe: `Non signalée comme une Entreprise Appartenant à l'État (EAE)`,
      reportHasPep: 'Signalée comme une Personne Politiquement Exposée (PPE)',
      reportNoPep: 'Non signalée comme une Personne Politiquement Exposée (PPE)',
      notSoeValidated: 'Non validée avec EEP',
    },
    company_name: "Nom de l'entreprise",
    company_plural: 'entreprises',
    conduct: 'Indicateur de risque',
    report_type: 'Type de rapport',
    connected_as: 'connecté comme',
    confirm_password: 'Confirmer votre mot de passe',
    consent_status: 'invitation',
    consent_statuses: 'invitations',
    copyright: '© {{year}} Valital Technologies Inc.',
    sso: 'connectez-vous avec SSO',
    // create_password: 'créez votre mot de passe ',
    credentials: 'Emplois',
    custom: 'personnalisé',
    custom_plan: '<span><strong>Plan</strong> personnalisé</span>',
    dark_mode: 'Mode sombre',
    dashboard: 'tableau de bord',
    delegate: 'utilisateur',
    delegate_1: 'Un utilisateur',
    delegate_plural: 'utilisateurs',
    department: 'département',
    discrimination: 'discrimination',
    done: 'terminé',
    downgrade: 'sélectionner',
    email: 'Courriel',
    end_date: 'Date de fin',
    enrolment_period: "Période de l'inscription",
    features: 'fonctionnalités',
    financial: 'fraude',
    first_name: 'Prénom',
    global_results: 'sommaire',
    green: 'vert',
    harassment: ' harcèlement',
    help_and_support: 'Aide et Support',
    high_risk: 'risque élevé',
    history: 'historique',
    identity_matching: "validation de l'identité",
    inactive_users: 'utilisateurs inactifs',
    individual: 'Individu',
    organization: 'Organization',
    individual_plural: 'Individus',
    integrations: 'intégrations',
    in: 'en',
    invite: "l'invitation",
    investigate: 'examiner',
    inconclusive: 'non concluant',
    invoices: {
      invoices: 'Factures',
      date: 'Date',
      invoice_number: 'No. de facture',
      status: 'Statut',
      amount: 'Montant',
      statuses: {
        paid: 'payée',
        draft: 'brouillon',
        void: 'nul',
        open: 'ouverte',
        uncollectible: 'irrécouvrable',
      },
      last_payment: 'Dernier paiement',
      payment_amount: 'Montant du paiement',
    },
    last_name: 'Nom de Famille',
    last_request: 'dernière requête',
    legal: 'légal',
    less: 'moins',
    less_likely: 'moins probable',
    likely: 'probable',
    live: 'en temps réel',
    prefrence_text:
      'Activer ou désactiver liveUpdate par défaut pour toutes les nouvelles validations',
    private_validations_by_default: 'Validations privées',
    private_validations_by_default_text:
      'Activer ou désactiver les validations privées par défaut pour toutes les nouvelles validations',
    default_validation_settings_title: 'Paramètres de validation par défaut',
    default_validation_settings_subtitle:
      'Définissez les paramètres par défaut des nouvelles validations.',
    default_live_update_settings_title: 'Paramètres LiveUpdate par défaut',
    default_live_update_settings_subtitle:
      'Définissez les paramètres par défaut des nouvelles validations.',
    default_validation_live_updates_label: 'LiveUpdate',
    default_validation_live_updates_description:
      'Choisissez une fréquence pour activer la surveillance continue et être avisé des nouvelles informations.',
    default_validation_private_label: 'Privé',
    default_validation_private_description:
      'Gardez les validations privées. Elles ne seront visibles que par le propriétaire du compte, l’administrateur du compte et l’administrateur d’équipe. Vous pouvez modifier ces paramètres lors de la soumission d’une validation.',
    default_validation_pep_soe_label: 'PPE/EAE',
    default_validation_pep_soe_description:
      'Inclure le signalement des personnes politiquement exposées (PPE) et des entreprises appartenant à l’État (EAE).',
    update_preference_settings: 'Mettre à jour les paramètres',
    preference_settings_saved: 'Paramètres de validation par défaut mis à jour',
    preference_settings_save_failed:
      'Impossible d’enregistrer les paramètres. Veuillez réessayer.',
    preference_private_enabled:
      'Les nouvelles validations seront privées par défaut',
    preference_private_disabled:
      'Les nouvelles validations ne seront plus privées par défaut',
    preference_pep_soe_enabled:
      'Le dépistage PPE/EAE sera demandé pour les nouvelles validations',
    preference_pep_soe_disabled:
      'Le dépistage PPE/EAE ne sera plus demandé pour les nouvelles validations',
    live_update: 'LiveUpdate',
    live_validation: 'LiveUpdate',
    up_to: "jusqu'à {{count}}",
    validation_labels: 'Étiquettes',
    live_validations: 'LiveUpdate',
    extend_search: 'Recherche étendue',
    not_trusted: 'Pas de confiance',
    location: 'Emplacement',
    locations: 'Emplacements',
    month: 'mois',
    month_plural: 'mois',
    most: 'plus',
    most_likely: 'plus probable',
    name: 'nom',
    name_location: 'nom & emplacement',
    never: 'jamais',
    new: 'nouveau',
    new_feminine: 'nouvelle',
    new_validation: 'Nouvelle validation',
    news: 'nouvelles',
    next: 'suivant',
    new_instant_validation: 'Mettre à jour la validation',
    new_password: 'Nouveau mot de passe',
    nick_name: 'Autre Prénom (optionnel)',
    alternative_first_name: 'Autre Prénom (optionnel)',
    no: 'non',
    notable_themes: 'thèmes importants',
    notifications: 'notifications',
    off: 'non',
    ok: 'ok',
    old_password: 'Ancien mot de passe',
    optional: 'optionnel',
    on: 'oui',
    other: 'autres',
    other_results: 'autres résultats',
    password: 'mot de passe',
    code: 'code',
    pending_consent: 'invitation en attente',
    pending_consent_plural: 'invitations en attente ',
    period_worked: ' période travaillée',
    personal_info: 'informations personnelles',
    per_month: 'par mois',
    phone_number: 'Numéro de téléphone',
    plan: 'plan',
    plans_for_every_org: 'Un plan pour toute organisation',
    plan_type: 'Plan: {{planType}}',
    plan_validation_number:
      '<span><strong>Fonctionnalités</strong> avancées</span>',
    positions: 'organisations',
    previous: 'précédent',
    pending_verification: 'Préliminaire',
    pending_verification_report: 'Rapport  Préliminaire',
    pending_articles_verification: 'En attente de vérification des articles',
    pending_twitter_verification: 'En attente de vérification de Twitter',
    new_twitter_validation:
      'Exécuter une nouvelle <br/>validation avec Twitter',
    privacy_statement: 'Déclaration de confidentialité',
    profile: 'profil',
    province: 'province',
    province_state: 'Province/État',
    red: 'rouge',
    reference_1: 'une référence',
    reference: 'référence',
    references: 'références',
    ready_for_validation: 'Prêt a valider',
    individuals_will_appear_here: 'Vos individus à valider apparaîtront ici.',
    organizations_will_appear_here:
      'Vos organisations à valider apparaîtront ici.',
    reminder: 'rappel',
    report_page: {
      idMatch: 'Identifiant',
      id_match: 'Identifiant',
      STRONG: 'FORT',
      WEAK: 'FAIBLE',
      article: 'Article',
      article_plural: 'Articles',
      articles: 'Articles',
      LIVE: 'EN CONTINU',
      INSTANT: 'INSTANT',
      source: 'Source',
      credible: 'CREDIBLE',
      ALL: 'TOUT',
      found_on: 'Trouvé le',
    },
    request: 'requête',
    reset_password: 'réinitialiser le mot de passe',
    create_password: 'Créer un mot de passe',
    risk_indicator: 'Indicateur de risque',
    risk: 'Risque',
    role: 'titre',
    role_name: 'Rôle ou Titre',
    role_plural: 'titres',
    row: 'ligne',
    row_plural: 'lignes',
    security_settings: 'Paramètres de sécurité',
    selected: 'sélectionné',
    select: 'sélectionner',
    settings: 'Paramètres',
    start_date: 'Date de début',
    status: 'statut',
    summary: 'résumé',
    success: 'Réussi',
    switch_language: 'english',
    talent: 'talent',
    talent_plural: 'talents',
    talent_SECURITY: 'individu',
    talent_SECURITY_plural: 'individus',
    terms_of_use: "Conditions d'utilisation",
    twitter: 'twitter',
    unavailable: 'non disponible',
    upgrade: 'sélectionner',
    user: 'utilisateur',
    usage_and_credits: 'Utilisation & crédits',
    pay_as_you_go: 'Paiement à l’usage',
    usage_dashboard_title: 'Tableau d’utilisation',
    usage_dashboard_subtitle:
      'Suivez votre abonnement et votre utilisation. Toutes les dates sont en UTC.',
    usage_your_subscription: 'Votre abonnement',
    usage_credits_used: 'crédits utilisés',
    credits_used: 'crédits utilisés',
    credits_remaining: 'crédits restants',
    usage_this_utc_month: 'Ce mois-ci',
    usage_projected_by_renewal: 'Projection au renouvellement',
    usage_more_from_schedules: 'de plus selon les fréquences actuelles',
    usage_entities_by_frequency: 'Entités par fréquence de mise à jour',
    usage_scheduled_title: 'Entités',
    usage_entities_heading: 'Entités',
    usage_scheduled_hint:
      'Entités avec liveUpdate activées en ce moment (par fréquence). Ce n’est pas l’utilisation facturable.',
    usage_schedule_this_month: 'Unités de crédit par fréquence (ce mois)',
    usage_over_subscribed_copy:
      'Vous avez dépassé vos crédits souscrits. liveUpdate et l’API continuent de fonctionner; le dépassement est facturé selon votre entente.',
    usage_near_limit_copy:
      'Vous avez utilisé au moins 80 % de vos crédits souscrits.',
    usage_limit_reached_copy:
      'Vous avez atteint 100 % de vos crédits souscrits.',
    usage_paygo_lu_note: 'Aucun pool de crédits; l’utilisation est mesurée selon votre entente.',
    usage_chart_validations_title: 'Utilisation des validations par mois',
    usage_chart_validations_subtitle: 'Suivez votre consommation de validations dans le temps',
    usage_chart_lu_title: 'Utilisation LiveUpdate par mois',
    usage_chart_lu_subtitle: 'Suivez votre consommation de crédits liveUpdate dans le temps',
    usage_chart_empty: 'Aucune donnée d’utilisation pour la période sélectionnée.',
    usage_by_day: 'Utilisation par jour',
    usage_by_week: 'Utilisation par semaine',
    usage_by_month: 'Utilisation par mois',
    usage_by_year: 'Utilisation par année',
    usage_granularity_day: 'Jour',
    usage_granularity_week: 'Semaine',
    usage_granularity_month: 'Mois',
    usage_granularity_year: 'Année',
    usage_view_by_month: 'Mois',
    usage_previous_subscriptions: 'Abonnements précédents',
    usage_previous_subscriptions_subtitle: 'Historique de vos abonnements',
    usage_monthly_history: 'Historique mensuel',
    usage_monthly_history_note:
      'Mois calendaires depuis le début de l’abonnement. Les valeurs liveUpdate sont des unités de crédit (1 par exécution facturable).',
    usage_days_count: '{{count}} jours',
    usage_billing_unavailable: 'Les informations d’utilisation ne sont pas disponibles pour votre compte.',
    usage_lu_unavailable: 'La facturation LiveUpdate n’est pas activée pour votre compte.',
    usage_view_usage_link: 'Utilisation & crédits',
    days_until_renewal: 'Jours avant le renouvellement',
    renewal_date: 'Date de renouvellement',
    start_date: 'Date de début',
    credits: 'Crédits',
    used: 'utilisé',
    remaining: 'restant',
    of_subscribed: 'du souscrit',
    daily_live_update: 'LiveUpdate quotidien',
    weekly_live_update: 'LiveUpdate hebdomadaire',
    monthly_live_update: 'LiveUpdate mensuel',
    live_update_frequency_daily: 'quotidiennes',
    live_update_frequency_weekly: 'hebdomadaires',
    live_update_frequency_monthly: 'mensuelles',
    live_update_credits: 'Crédits LiveUpdate',
    period: 'Période',
    month: 'Mois',
    total: 'Total',
    live_update_last_check: 'Dernière exécution facturable :',
    live_update_next_check: 'Prochain contrôle prévu (estimation) :',
    live_update_next_tooltip_at_time: 'Prochaine mise à jour à {{time}}',
    live_update_next_tooltip_on_date: 'Prochaine mise à jour le {{date}}',
    default_live_update_schedule_title: 'Fréquence LiveUpdate par défaut',
    usage_pending_credits: 'Unités de crédit en attente (en cours, pas encore facturables)',
    usage_schedule_sum_note:
      'La somme des unités quotidiennes, hebdomadaires et mensuelles doit correspondre au total du mois une fois toutes les exécutions facturables enregistrées.',
    usage_schedule_sum_mismatch:
      'Somme de l’échéancier {{sum}} vs total du mois {{month}} — un écart peut apparaître brièvement pendant l’enregistrement des exécutions.',
    usage_percent_80_chip: '≥ 80 % utilisé',
    live_update_alert_settings_title: 'Notifications courriel LiveUpdate',
    live_update_alert_settings_subtitle:
      'Les valeurs par défaut pour les nouvelles validations s’appliquent lorsque vous activez liveUpdate; vous pouvez les modifier sur chaque rapport. S’applique uniquement aux courriels de la plateforme.',
    live_update_alert_criteria_title: 'Quand',
    live_update_alert_new_articles: 'De nouveaux liens sont signalés',
    live_update_alert_risk_change: 'Indicateur de risque de validation modifié',
    live_update_alert_criteria_webhook_title: 'M’avertir lorsque…',
    live_update_alert_risk_threshold: 'Pour ces niveaux de risque :',
    live_update_alert_threshold_ALL: 'Tous les niveaux de risque',
    live_update_alert_threshold_HIGH_RISK: 'Risque élevé',
    live_update_alert_threshold_INVESTIGATE: 'À investiguer',
    live_update_alert_threshold_INCONCLUSIVE: 'Non concluant',
    live_update_alert_threshold_CLEAR: 'Clair',
    live_update_alert_recipients_title: 'Qui',
    live_update_alert_recipient_enabled_user:
      "Utilisateur ayant activé liveUpdate",
    live_update_alert_recipient_owner_admins: 'Propriétaire du compte et administrateurs',
    live_update_alert_recipient_all_validators: 'Tous les validateurs de la validation',
    live_update_alert_recipient_owner: 'Propriétaire du compte et administrateurs',
    live_update_alert_recipient_specific: 'Utilisateurs sélectionnés',
    live_update_alert_recipient_custom_email: 'Adresse courriel personnalisée',
    live_update_alert_custom_email_label: 'Adresse courriel',
    live_update_alert_custom_email_placeholder: 'nom@entreprise.com',
    live_update_alert_custom_email_hint:
      'Si cette option est sélectionnée, les notifications sont aussi envoyées à cette adresse.',
    live_update_alert_need_one_recipient: 'Sélectionnez au moins un destinataire.',
    live_update_alert_summary_risk_change:
      'Vous recevrez un courriel lorsque le niveau de risque de cette validation change.',
    live_update_alert_summary_new_articles_all_levels:
      'Vous recevrez un courriel lorsqu’un nouvel article est trouvé, à tout niveau de risque.',
    live_update_alert_summary_new_articles_levels:
      'Vous recevrez un courriel lorsqu’un nouvel article est trouvé aux niveaux : {{levels}}.',
    live_update_alert_summary_recipient_enabled_user:
      "l'utilisateur qui a activé liveUpdate",
    live_update_alert_summary_recipient_owners:
      'les propriétaires du compte et les administrateurs',
    live_update_alert_summary_recipient_custom: '{{email}}',
    live_update_alert_summary_recipient_default: 'les destinataires sélectionnés',
    live_update_alert_custom_email_invalid: 'Entrez une adresse courriel valide.',
    live_update_alert_pick_users: 'Utilisateurs',
    live_update_alert_pick_users_placeholder: 'Saisir un nom ou un courriel…',
    live_update_alert_pick_users_hint:
      'Commencez à taper pour rechercher des utilisateurs, puis choisissez dans la liste.',
    live_update_alert_pick_users_no_match: 'Aucun utilisateur ne correspond à la recherche',
    live_update_alert_save: 'Enregistrer',
    live_update_alert_saved: 'Paramètres d’alerte enregistrés',
    live_update_alert_save_failed: 'Impossible d’enregistrer les paramètres d’alerte',
    live_update_alert_use_company_defaults:
      'Utiliser les paramètres d’alerte par défaut de l’entreprise',
    live_update_alert_validation_override_hint:
      'Ces paramètres s’appliquent à cette validation seulement. Les valeurs par défaut de l’entreprise se trouvent sous Profil → LiveUpdate.',
    live_update_alert_need_one_criterion:
      'Choisissez au moins une condition d’alerte (par exemple nouveaux articles ou changement de risque).',
    user_management: 'Gestion des utilisateurs',
    user_plural: 'utilisateurs',
    user_type: 'permission',
    validation: 'validation',
    validation_plural: 'validations',
    validation_date: 'dernière date de validation',
    violence: 'violence',
    year: 'an',
    year_plural: 'ans',
    yellow: 'jaune',
    yes: 'oui',
    quantity: 'Quantité',
    pricing_details: 'Détails de facturation',
    item: 'Article',
    unit_price: 'Prix unitaire',
    amount: 'Montant',
    total: 'total',
    total_validation_period: 'Période de validation totale',
    userMessagesUnread: 'Salut, you have unread message.',
    validation_report: 'État du rapport',
    total_links: '{{totalLinks}} liens',
    links: 'Liens',
    link: 'Lien',
    verified_estimate: {
      verifying: 'Vérifié sous peu...',
      within_hours: 'Vérifié d’ici {{hours}}h',
      within_monday: 'Vérifié avant lundi 9h',
    },
    pdf_report: {
      header: 'Rapport des nouvelles en ligne',
      powered_by: 'Alimenté par',
      view_on_twitter: 'Voir sur Twitter',
      posted_on: 'Publié le',
      is_subject: 'est participant',
      not_subject: 'est mentionné',
      missconduct: 'Inconduite',
      subTopics: 'Sous-thèmes',
      found_on: 'Trouvé le',
      from: 'De',
      links_analysed: 'Liens analisés',
      created_by: 'Rapport créé par {{name}}',
      english: 'Anglais',
      french: 'Français',
      spanish: 'Espagnol',
      portuguese: 'Portugais',
      how_to_read_this_report: 'Comment lire ce rapport',
      pep_card_title: 'Personne Politiquement Exposée',
    },
    sources: 'Sources',
  },
  options: {
    role: {
      talent_acquisition: 'Acquisition de Talents',
      executive: 'VP / Exécutif',
      hr_consultant: 'Consultant(e) en RH',
      other: 'Autre',
    },
  },
  verbs: {
    accepted: 'accepté',
    add: 'ajouter',
    add_individual: "Ajouter l'individu",
    add_organization: "Ajouter l'organisation",
    add_without_company: 'Ajouter sans entreprise',
    added: 'ajouté',
    apply: 'appliquer',
    archive: 'archiver',
    archived: 'archivé',
    back: 'retour',
    back_to: 'Retour à',
    cancel: 'Annuler',
    save: 'Enregistrer',
    changed: 'changé',
    change_access_type: "changer les types d'accès",
    change_activity_status: "changer le statut d'activité",
    remove_access: "Supprimer l'accès",
    grant_access: "Autoriser l'accès",
    change_plan: 'changer le plan',
    change_plan_capitalized: 'Modifier votre plan',
    changed_plural: 'changés',
    close: 'Fermer',
    confirm: 'Confirmer',
    confirmed: 'confirmée',
    contact_us: 'contactez-nous',
    continue: 'continuer',
    connect: 'Connecter',
    created_by: 'créé par',
    deactivate: 'désactiver',
    decline: 'décliner',
    declined: 'déclinée',
    declined_plural: 'déclinées',
    disable: 'désactiver',
    disconnect: 'Déconnecter',
    denied: 'refusé',
    delete: 'effacer',
    ok: 'OK',
    update_privacy: 'Basculer en ',
    edit: 'modifier',
    enable: 'activer',
    enroll: 'inscrire',
    filter: 'filtrer',
    finalize: 'finaliser',
    finish: 'terminer',
    get_started: 'Enregistrez-vous',
    go_back: 'fermer',
    go_to: 'aller à',
    invite: 'inviter',
    in_progress: 'En Progrès',
    last_validated: 'dernière mise à jour',
    last_validated_on: 'Dernière mise à jour le',
    loading: 'chargement en progrès',
    login: 'se connecter',
    login_with: 'se connecter avec',
    logout: 'se déconnecter',
    new_individual: 'Nouvel Individu',
    new_organization: 'Nouvelle organisation',
    pending: 'en attente',
    language: "Langue de l'article",
    published_on: 'Publié le {{date}}',
    no_publish_date: 'Aucune date de publication',
    purchase: 'acheter',
    reactivate: 'réactiver',
    refused: 'déclinée',
    remind: 'renvoyer',
    remove: 'supprimer',
    revoke: 'révoquer',
    run_validation: 'effectuer la validation',
    send: 'envoyer',
    send_code: 'Envoyer le code',
    sending: 'envoi',
    sent: 'envoyé',
    show: 'Afficher',
    started: 'démarré',
    submit: 'soumettre',
    update: 'mettre à jour',
    updated: 'Mis à jour',
    verify: 'Vérifier',
    verifying: 'Vérification',
    switching: 'changement',
    removing: 'Suppression...',
    updated_feminine: 'Mise à jour',
    upgrade_plan: 'Réhaussez votre plan',
    select_plan: 'Choisir un plan',
    upload_image: "télécharger_l'image",
    update_individual: "mettre à jour l'individu",
    update_organization: "mettre à jour l'organisation",
    update_validation: 'Mettre à jour la validation',
    update_information: 'Mettre à jour',
    validated: 'validé',
    validated_by: 'validé par',
    reviewed_by: 'Revu par',
    validated_feminine_plural: 'validées',
    validate_new_individual: 'Valider Un Individu ',
    validate_as_new_individual: 'Valider comme nouveau',
    validate_new_organization: 'Valider une organisation',
    view: 'visionner le',
    cancel_subscription: "Annuler l'abonnement",
    add_to_plan: 'Ajouter au plan',
    finalize_purchase: "Finaliser l'achat",
    make_admin: 'Rendre admin',
    make_delegate: 'Rendre déléguer',
    unarchive: 'Désarchiver',
  },
  actions: {
    switch_to_light_mode: 'Passer au mode clair',
    switch_to_dark_mode: 'Passer au mode sombre',
  },
  country: {
    AF: 'Afghanistan',
    AL: 'Albanie',
    DZ: 'Algérie',
    AS: 'Samoa des États-Unis',
    AD: 'Andorre',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctique',
    AG: 'Antigua-et-Barbuda',
    AR: 'Argentine',
    AM: 'Arménie',
    AW: 'Aruba',
    AU: 'Australie',
    AT: 'Autriche',
    AZ: 'Azerbaïdjan',
    BS: 'Bahamas',
    BH: 'Bahreïn',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Bélarus',
    BE: 'Belgique',
    BZ: 'Belize',
    BJ: 'Bénin',
    BM: 'Bermudes',
    BT: 'Bhoutan',
    BO: 'Bolivie',
    BA: 'Bosnie-et-Herzégovine',
    BW: 'Botswana',
    BR: 'Brésil',
    IO: "Territoire britannique de l'Océan océan de la mer de l'Indes (BIOT)",
    BN: 'Brunéi',
    BG: 'Bulgarie',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodge',
    CM: 'Cameroune',
    CA: 'Canada',
    CV: 'Cap-Vert',
    KY: 'Îles Caiman',
    CF: 'République centrafricaine',
    TD: 'Tchad',
    CL: 'Chili',
    CN: 'Chine',
    CX: 'Île Christmas',
    CC: 'Îles Cocos (Keeling)',
    CO: 'Colombie',
    KM: 'Comores',
    CG: 'Congo',
    CD: 'Congo (RDC)',
    CK: 'Îles Cook',
    CR: 'Costa Rica',
    CI: "Côte d'Ivoire",
    HR: 'Croatie',
    CU: 'Cuba',
    CW: 'Curaçao',
    CY: 'Chypre',
    CZ: 'République tchèque',
    DK: 'Danemarque',
    DJ: 'Djibouti',
    DM: 'Dominique',
    DO: 'République dominicaine',
    EC: 'Équateur',
    EG: 'Égypte',
    SV: 'El Salvador',
    GQ: 'Guinée équatoriale',
    ER: 'Érythrée',
    EE: 'Estonie',
    ET: 'Éthiopie',
    FK: 'Îles Falkland (Malouines)',
    FO: 'Îles Féroé',
    FJ: 'Fiji',
    FI: 'Finlande',
    FR: 'France',
    GF: 'Guyane française',
    PF: 'Polynésie française',
    TF: 'Territoires français du sud',
    GA: 'Gabon',
    GM: 'Gambie',
    GE: 'Géorgie',
    DE: 'Allemagne',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Grèce',
    GL: 'Groenlande',
    GD: 'Grenade',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernesey',
    GN: 'Guinée',
    GW: 'Guinée-Bissau',
    GY: 'Guyane',
    HT: 'Haïti',
    HM: 'Île Heard et Îles McDonald',
    VA: 'Cité du Vatican',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hongrie',
    IS: 'Islande',
    IN: 'Inde',
    ID: 'Indonésie',
    IR: 'Iran',
    IQ: 'Irak',
    IE: 'Irlande',
    IM: 'Île de Man',
    IL: 'Israël',
    IT: 'Italie',
    JM: 'Jamaïque',
    JP: 'Japon',
    JE: 'Jersy',
    JO: 'Jordanie',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: 'Corée du Nord',
    KR: 'Corée du Sud',
    KW: 'Koweït',
    KG: 'Kirghizstan',
    LA: 'Laos',
    LV: 'Lativie',
    LB: 'Liban',
    LS: 'Lesotho',
    LR: 'Liberie',
    LY: 'Libye',
    LI: 'Liechtenstein',
    LT: 'Lituanie',
    LU: 'Luxembourg',
    MO: 'Macau',
    MK: 'Macédoine du Nord',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaisie',
    MV: 'Maldives',
    ML: 'Malie',
    MT: 'Malte',
    MH: 'Îles Marshall',
    MQ: 'Martinique',
    MR: 'Mauritanie',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexique',
    FM: 'Micronésie',
    MD: 'Moldavie',
    MC: 'Monaco',
    MN: 'Mongolie',
    ME: 'Monténégro',
    MS: 'Montserrat',
    MA: 'Maroc',
    MZ: 'Mosambique',
    MM: 'Myanmar',
    NA: 'Namibie',
    NR: 'Nauru',
    NP: 'Népal',
    NL: 'Pays-Bas',
    NC: 'N ouvelle-Calédonie',
    NZ: 'Nouvelle-Zélande',
    NI: 'Nic aragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Î le Norfolk',
    MP: 'Î les Mariannes du Nord',
    NO: 'Norvège',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestine',
    PA: 'Panama',
    PG: ' papoue-Nouvelle-Gu inée',
    PY: 'Paraguay',
    PE: 'Pérou',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Pologne',
    PT: 'Portugal',
    PR: 'Porto Rico',
    QA: 'Qatar',
    RE: 'Ré union',
    RO: 'Roumanie',
    RU: 'République russe',
    RW: 'Rwanda',
    BL: 'Saint-Barthélémy',
    SH: 'Saint-Hélène, Ascension et Tristan da_Cunha',
    KN: 'Saint-Christophe-et-Nevis',
    LC: 'Sainte-Lucie',
    MF: 'Saint-Martin (partie française)',
    PM: 'Saint-Pierre-et-Miquelon',
    VC: 'Saint-Vincent-et-les-Grenadines',
    WS: 'Samoa',
    SM: 'Saint-Marin',
    ST: 'S ao Tomé-et-Principe',
    SA: 'Arabie saoudite',
    SN: 'Sénégal',
    RS: 'Serbie',
    SC: 'Séychelles',
    SL: 'Sierra-Leone',
    SG: 'Singapoure',
    SX: 'Sint-Martin (partie néerlandaise)',
    SK: 'Slovaquie',
    SI: 'Slovénie',
    SB: 'Î les Solomon',
    SO: 'Soma lie',
    ZA: 'Afrique du Sud',
    GS: 'Géorgie du Sud et Î les Sandwich du Sud',
    SS: 'Soudan',
    ES: 'Espagne',
    LK: 'Sri Lanka',
    SD: 'Soudan',
    SR: 'Surinam',
    SJ: 'Svalbard et Jan Mayen',
    SZ: 'Eswatini (Swaziland)',
    SE: 'Suède',
    CH: 'Suisse',
    SY: 'Srie',
    TW: 'Taïwan',
    TJ: 'Tadjikistan',
    TZ: 'Tanzanie',
    TH: 'Thaïlande',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad-et-Tobago',
    TN: 'Tunisie',
    TR: 'Turquie',
    TM: 'Turkmenistan',
    TC: 'Î les Turques et Caïques',
    TV: 'Tuvalu',
    UG: 'Ouganda',
    UA: 'Ukraine',
    AE: 'Émirats arabes unis',
    GB: 'Royaume-Uni',
    US: "États-Unis d'Amérique",
    UM: 'Î les éloignés des États-Unis',
    UY: 'Uruguay',
    UZ: 'Ouzbékistan',
    VU: 'Vanouatu',
    VE: 'Vénzuela',
    VN: 'Viêt nam',
    VG: 'Î les vierges (britanniques)',
    VI: 'Î les vierges (États-Unis)',
    WF: 'Wallis-et-Futuna',
    EH: 'Sahara occidentale',
    YE: 'Y emen',
    ZM: 'Za mbie',
    ZW: 'Zim babwe',
  },
};

export default glossary;
